export function getNotificationTargetUrl(notification) {
  const targetUrl = String(notification?.targetUrl || '').trim();
  if (!targetUrl || !targetUrl.startsWith('/') || targetUrl.startsWith('//')) return '';
  return targetUrl;
}
